import MaterialPagination from './MaterialPagination';

export default MaterialPagination;
